var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLessThanOrEqualTo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "less than or equal to",
  d: "m4 5.35 8.5 3.51-.63 1.84L1.5 6.31V4.39L11.87 0l.63 1.85ZM1.5 12.1h11V14h-11Z"
})));
export default SvgLessThanOrEqualTo;